import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { isStaff } from '../../initial_state'
import {
  addShortcut,
  removeShortcut,
} from '../../actions/shortcuts'
import { blockGroup, unblockGroup } from '../../actions/groups'
import {
  isBlockingGroupId,
} from '../../utils/local_storage_blocks_mutes'
import {
  openPopover,
  closePopover,
} from '../../actions/popover'
import { POPOVER_SHARE } from '../../constants'
import PopoverLayout from './popover_layout'
import List from '../list'

class GroupOptionsPopover extends ImmutablePureComponent {

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  handleOnToggleShortcut = () => {
    this.handleOnClosePopover()
    if (this.props.isShortcut) {
      this.props.onRemoveShortcut(this.props.group.get('id'))
    } else {
      this.props.onAddShortcut(this.props.group.get('id'))
    }
  }

  handleOnShare = () => {
    this.props.onShare(this.props.group)
  }

  handleOnBlock = () => {
    this.handleOnClosePopover()
    this.props.onBlock(this.props.group.get('id'))
  }

  handleOnUnBlock = () => {
    this.handleOnClosePopover()
    this.props.onUnBlock(this.props.group.get('id'))
  }

  render() {
    const {
      group,
      isAdmin,
      isShortcut,
      isXS,
      isMember,
    } = this.props

    if (!group) return <div/>

    const groupId = group.get('id')

    const listItems = []
    if (isAdmin) {
      listItems.push({
        hideArrow: true,
        icon: 'group',
        title: 'Group members',
        onClick: this.handleOnClosePopover,
        to: `/groups/${groupId}/members`,
        isHidden: !isAdmin,
      })
      listItems.push({
        hideArrow: true,
        icon: 'block',
        title: 'Removed accounts',
        onClick: this.handleOnClosePopover,
        to: `/groups/${groupId}/removed-accounts`,
        isHidden: !isAdmin,
      })
      listItems.push({
        hideArrow: true,
        icon: 'pencil',
        title: 'Edit group',
        onClick: this.handleOnClosePopover,
        to: `/groups/${groupId}/edit`,
        isHidden: !isAdmin,
      })
      listItems.push({})
    }
      
    listItems.push({
      hideArrow: true,
      icon: 'share',
      title: 'Share group',
      onClick: this.handleOnShare,
    })
    listItems.push({})
    listItems.push({
      hideArrow: true,
      icon: isShortcut ? 'star' : 'star-outline',
      title: isShortcut ? 'Remove from shortcuts' : 'Add to shortcuts',
      onClick: this.handleOnToggleShortcut,
    })

    if (isStaff) {
      listItems.push({})
      listItems.push({
        title: 'Open mod interface for group',
        href: `/admin/groups/${groupId}`,
        openInNewTab: true,
      })
    }

    if (!isBlockingGroupId(groupId)) {
      listItems.push({})
      listItems.push({
        icon: 'audio-mute',
        title: 'Mute Group',
        onClick: this.handleOnBlock,
        hideArrow: true,
      })
    } else {
      listItems.push({})
      listItems.push({
        icon: 'audio-mute',
        title: 'Unmute Group',
        onClick: this.handleOnUnBlock,
        hideArrow: true,
      })
    }

    return (
      <PopoverLayout
        width={240}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        <List
          scrollKey='group_options'
          items={listItems}
          size={isXS ? 'large' : 'small'}
        />
      </PopoverLayout>
    )
  }

}

const mapStateToProps = (state, { group }) => {
  const groupId = group ? group.get('id') : null
  const shortcuts = state.getIn(['shortcuts', 'items'])
  const isShortcut = !!shortcuts.find((s) => {
    return s.get('shortcut_id') == groupId && s.get('shortcut_type') === 'group'
  })
  return { isShortcut }
}

const mapDispatchToProps = (dispatch, { innerRef }) => ({
  onClosePopover: () => dispatch(closePopover()),
  onAddShortcut(groupId) {
    dispatch(addShortcut('group', groupId))
  },
  onRemoveShortcut(groupId) {
    dispatch(removeShortcut(null, 'group', groupId))
  },
  onShare(group) {
    dispatch(openPopover(POPOVER_SHARE, {
      innerRef,
      group,
      position: 'top',
    }))
  },
  onBlock(groupId) {
    dispatch(blockGroup(groupId))
  },
  onUnBlock(groupId) {
    dispatch(unblockGroup(groupId))
  },
})

GroupOptionsPopover.defaultProps = {
  group: ImmutablePropTypes.map.isRequired,
  isAdmin: PropTypes.bool,
  isMember: PropTypes.bool,
  isXS: PropTypes.bool,
  isShortcut: PropTypes.bool,
  onAddShortcut: PropTypes.func.isRequired,
  onRemoveShortcut: PropTypes.func.isRequired,
  onClosePopover: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupOptionsPopover)